import { render, staticRenderFns } from "./IsOlderSecond.vue?vue&type=template&id=2c506018&scoped=true&lang=pug&"
import script from "./IsOlderSecond.vue?vue&type=script&lang=js&"
export * from "./IsOlderSecond.vue?vue&type=script&lang=js&"
import style0 from "./IsOlderSecond.vue?vue&type=style&index=0&id=2c506018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c506018",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c506018')) {
      api.createRecord('2c506018', component.options)
    } else {
      api.reload('2c506018', component.options)
    }
    module.hot.accept("./IsOlderSecond.vue?vue&type=template&id=2c506018&scoped=true&lang=pug&", function () {
      api.rerender('2c506018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/IsOlderSecond.vue"
export default component.exports